export const businessPlanGettingStartedArticle = {
  title: 'Business Plan Generator: Getting Started',
  slug: 'business-plan-getting-started',
  content: `Business Plan Generator: Getting Started

Generate and manage business plans tied to your saved ideas.

1) Open the Business Plan module
- Go to /business-plan.
- Saved ideas and saved plans load on the left.

2) Choose an idea
- Select a saved business idea to anchor the plan.
- If no ideas exist, create one in the Idea Generator first.

3) Start a new plan
- Click “Create New Plan”.
- Choose: use a saved idea or write a custom idea.

4) Use templates or wizard
- Optional: pick an industry template before the wizard.
- Complete the wizard to generate the plan sections.
`,
};
